import { LocalizedText, useDateTimeLocalizationInfo } from '@mews/framework';
import { Body, Stack, StackItem, Typography } from '@optimus-web/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { useAvailabilityBlockInfo } from '../../utils/useAvailabilityBlockInfo';
import { getBlockAdjustmentAvailableNumber } from '../../selectors';
import { getBlockReleaseStrategyView } from '../../utils/getBlockReleaseStrategyView';
import { AvailabilityBlockDatesMenu } from './AvailabilityBlockDatesMenu';

interface ReleaseDateProps {
    availabilityBlockId: string;
    isEditingAvailability: boolean;
}

export const ReleasedDate = ({ availabilityBlockId, isEditingAvailability }: ReleaseDateProps) => {
    const localizationInfo = useDateTimeLocalizationInfo();
    const { availabilityBlock } = useAvailabilityBlockInfo(availabilityBlockId);
    const available = useCommanderSelector((s) => getBlockAdjustmentAvailableNumber(s, { availabilityBlockId }));
    const isReleasable = available > 0;

    if (!availabilityBlock) {
        return null;
    }

    const { textKey, value } = getBlockReleaseStrategyView(availabilityBlock, localizationInfo);

    return (
        <Stack spacing="100" distribution="space-between" itemAlignment="center" fill>
            <StackItem minWidth="0" grow>
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    <LocalizedText textKey={textKey} />
                </Typography>
                <Body whiteSpace="nowrap" ellipsis>
                    {value}
                </Body>
            </StackItem>
            <StackItem padding="100">
                <AvailabilityBlockDatesMenu
                    availabilityBlockId={availabilityBlockId}
                    isEditingAvailability={isEditingAvailability}
                    isReleasable={isReleasable}
                />
            </StackItem>
        </Stack>
    );
};
